import { getMessages } from '../../../../../../../store/constants';

export const CHECKLIST_LABEL_CLOSE = getMessages().getText('common.close');
export const CHECKLIST_LABEL = getMessages().getText('card_form_checklist_done_status');
export const CHECKLIST_SAVE_BUTTON = getMessages().getText('card_form_checklist_save');

export const CHECKLIST_CONTROL_CLASS = 'card-details-checklist__control';
